import datos from "src/services/datos";

export const mermasUpdate = async (datosParams) => {
    const prd_mermas = new datos("prd_mermas");

    const response = await prd_mermas.produccionCreate(datosParams);
    return response;
};

export const estadoUpdate = async (datosParams) => {
    const prd_orden_produccion = new datos("prd_orden_produccion");

    const response = await prd_orden_produccion.produccionCambioEstado(datosParams);
    return response;

};

